import { Button } from "@/components/ui/button"
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog"

export function DialogPreviewRoute(): JSX.Element {
  return (
    <div className="mx-auto max-w-4xl px-8.5 py-11">
      <header className="mb-8">
        <div className="font-id text-eyebrow uppercase tracking-[0.16em] text-text-3">
          Primitive
        </div>
        <h1 className="mt-1 text-display text-text">Dialog</h1>
      </header>

      <Section title="Sizes">
        <Dialog>
          <DialogTrigger asChild>
            <Button>Open small</Button>
          </DialogTrigger>
          <DialogContent
            size="sm"
            title="Small dialog"
            description="Compact modal — 420px max."
          >
            <p className="text-body-sm text-text-2">Small dialog body content.</p>
          </DialogContent>
        </Dialog>

        <Dialog>
          <DialogTrigger asChild>
            <Button>Open medium</Button>
          </DialogTrigger>
          <DialogContent
            size="md"
            title="Medium dialog"
            description="The default — 560px max."
          >
            <p className="text-body-sm text-text-2">Medium dialog body content.</p>
          </DialogContent>
        </Dialog>

        <Dialog>
          <DialogTrigger asChild>
            <Button>Open large</Button>
          </DialogTrigger>
          <DialogContent
            size="lg"
            title="Large dialog"
            description="Roomier — 680px max."
          >
            <p className="text-body-sm text-text-2">Large dialog body content.</p>
          </DialogContent>
        </Dialog>
      </Section>
    </div>
  )
}

function Section({ title, children }: { title: string; children: React.ReactNode }): JSX.Element {
  return (
    <section className="mb-8">
      <h2 className="mb-3.5 font-id text-caption uppercase tracking-[0.16em] text-text-3">
        {title}
      </h2>
      <div className="flex flex-wrap items-center gap-3.5">{children}</div>
    </section>
  )
}
